// Disable TypeScript checking for this plain JS asset (addresses implicit-any / DOM nullability in the project's checker)
// @ts-nocheck

document.addEventListener('DOMContentLoaded', function () {
  // Find all loyalty blocks on the page
  var loyaltyBlocks = document.querySelectorAll('[data-loyalty-block]');
  if (!loyaltyBlocks || loyaltyBlocks.length === 0) return;

  function parseNumber(value) {
    var n = parseFloat(value);
    return isNaN(n) ? 0 : n;
  }

  function isSubscriptionSelected() {
    // Recharge renders shadow DOM; check any widget for selected subscription radio
    try {
      const widgets = document.querySelectorAll('recharge-subscription-widget');
      for (const widget of widgets) {
        // Shadow root might not be open immediately
        const sr = widget.shadowRoot;
        if (!sr) continue;
        const subInput = sr.querySelector('.rc-purchase-option__input[value="subscription"]');
        if (subInput && subInput.checked) return true;
      }
    } catch(e) { /* ignore */ }
    return false;
  }

  function updatePointsForBlock(blockEl, priceCents) {
    // priceCents is price in cents (or the shop's smallest currency unit)
    var pointValue = parseNumber(blockEl.getAttribute('data-point-value')) || 0;
    // Convert to major currency unit
    var major = priceCents / 100;
    var multiplier = isSubscriptionSelected() ? 2 : 1;
    var points = Math.round(major * pointValue * multiplier);

    var pointsEl = blockEl.querySelector('[data-loyalty-points-total]');
    var hiddenInput = blockEl.querySelector('[data-loyalty-current-price]');
    if (pointsEl) pointsEl.textContent = points;
    if (hiddenInput) hiddenInput.value = points; // legacy usage: still stores points
    // Persist the raw variant price (unmultiplied) for future recalculations on subscription toggle
    blockEl.dataset.lastPriceCents = String(priceCents);
  }

  loyaltyBlocks.forEach(function (blockEl) {
    // Initialize with data-initial-price if present
    var initialPrice = parseNumber(blockEl.getAttribute('data-initial-price')) || 0;
    updatePointsForBlock(blockEl, initialPrice);

    // Listen for variant change events from theme (many themes fire an event like 'variant:change' or update the DOM)
    // We'll attach a MutationObserver on the product form or listen to select change

    // Try to locate the closest product form or element that holds variant inputs for this product
    var productForm = blockEl.closest('form[action*="/cart/add"], form[data-product-form], [data-product-form]');

    // Fallback: watch for global custom event 'variant:changed' or 'variant-change' if theme emits one
    // Best-effort: observe select[name="id"] changes inside the productForm
    if (productForm) {
      var variantInput = productForm.querySelector('select[name="id"], input[name="id"]');
      if (variantInput) {
        productForm.addEventListener('change', function (evt) {
          // When change happens, try to find currently selected variant price from DOM
          var priceEl = productForm.querySelector('[data-product-price], .price, .product__price');
          var priceCents = null;

          // If price data attribute exists (in cents)
          if (priceEl && priceEl.hasAttribute('data-cents')) {
            priceCents = parseNumber(priceEl.getAttribute('data-cents'));
          }

          // Try to find input with current variant price in cents attribute
          var selected = productForm.querySelector('input[name="id"]:checked, select[name="id"]');
          if (selected && selected.dataset && selected.dataset.price) {
            priceCents = parseNumber(selected.dataset.price);
          }

          // As a fallback, try reading a global window.Shopify or variant object (common patterns)
          if (priceCents === null) {
            // Try Shopify.activeVariant
            if (window.Shopify && window.Shopify.activeVariant && window.Shopify.activeVariant.price !== undefined) {
              priceCents = parseNumber(window.Shopify.activeVariant.price);
            }
          }

          // Final fallback: if we can't find price, skip update
          if (priceCents !== null) {
            updatePointsForBlock(blockEl, priceCents);
          }
        });
      }

      // Also observe DOM changes inside the productForm to capture dynamic price updates
      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          // If nodes changed, attempt to find a price element in cents
          var priceEl = productForm.querySelector('[data-product-price], .price, .product__price');
          if (priceEl) {
            var priceCents = null;
            if (priceEl.hasAttribute('data-cents')) priceCents = parseNumber(priceEl.getAttribute('data-cents'));
            else if (priceEl.dataset && priceEl.dataset.cents) priceCents = parseNumber(priceEl.dataset.cents);
            else {
              // try to extract numeric from text (e.g. "£12.34")
              var text = priceEl.textContent || '';
              var extracted = text.replace(/[^0-9\.\,]/g, '').replace(',', '.');
              var floatVal = parseFloat(extracted);
              if (!isNaN(floatVal)) priceCents = Math.round(floatVal * 100);
            }

            if (priceCents !== null) updatePointsForBlock(blockEl, priceCents);
          }
        });
      });

      mo.observe(productForm, { attributes: true, childList: true, subtree: true });
    }

    // Listen for a common global event (themes often emit something like 'variant:changed')
    // Listen to legacy/custom variant change names plus theme-specific ones
    ['variant:change', 'variant:changed', 'variantChange', 'variant:changed.local', 'product:price-update', 'variant:selected', 'variant:update'].forEach(function (evtName) {
      document.addEventListener(evtName, function (evt) {
        var priceCents = null;
        // Theme variant events shape
        if (evt && evt.detail) {
          // Support both detail.variant and detail.resource
            var variantObj = evt.detail.variant || (evt.detail.resource && evt.detail.resource);
            if (variantObj && variantObj.price !== undefined) {
              priceCents = parseNumber(variantObj.price);
            }
        }
        if (priceCents != null) updatePointsForBlock(blockEl, priceCents);
      });
    });

    // Directly monitor the variant picker form (radio/select changes) to derive variant price from dataset if available
    var variantPickerForm = document.querySelector('.variant-picker__form');
    if (variantPickerForm) {
      variantPickerForm.addEventListener('change', function() {
        // Try to find active radio with data-variant-id and attempt to map price
        var activeRadio = variantPickerForm.querySelector('input[type="radio"][data-variant-id]:checked');
        if (activeRadio) {
          // Some themes store variant JSON elsewhere; look for a script[type="application/json"][data-variant-json]
          var variantId = activeRadio.getAttribute('data-variant-id');
          var variantDataScript = document.querySelector('script[data-product-variants-json]');
          if (variantDataScript) {
            try {
              var variants = JSON.parse(variantDataScript.textContent || '[]');
              var found = variants.find(function(v){ return String(v.id) === String(variantId); });
              if (found && found.price != null) {
                updatePointsForBlock(blockEl, parseNumber(found.price));
                return;
              }
            } catch(e) { /* ignore */ }
          }
        }
        // Fallback: trigger a price scan through mutation observer logic by forcing a micro task
        var priceEl = document.querySelector('[data-product-price]');
        if (priceEl && priceEl.hasAttribute('data-cents')) {
          updatePointsForBlock(blockEl, parseNumber(priceEl.getAttribute('data-cents')));
        }
      });
    }

    // Listen for Recharge subscription option changes via events or polling fallback
    document.addEventListener('recharge:widget:loaded', function(){
      // attempt immediate recalculation with current price
      var currentPrice = parseNumber(blockEl.getAttribute('data-initial-price')) || 0;
      updatePointsForBlock(blockEl, currentPrice);
    });
  });

  // Fallback: poll for subscription change (shadow DOM makes event tricky)
  var lastSubState = null;
  setInterval(function(){
    var sub = (function(){
      try { return isSubscriptionSelected(); } catch(e){ return false; }
    })();
    if (sub !== lastSubState) {
      lastSubState = sub;
      // Recalculate all blocks using their most recent shown price (we stored last value in hidden input)
      loyaltyBlocks.forEach(function(blockEl){
        var basePrice = parseNumber(blockEl.dataset.lastPriceCents) || parseNumber(blockEl.getAttribute('data-initial-price')) || 0;
        updatePointsForBlock(blockEl, basePrice);
      });
    }
  });
});
